<script lang="ts">
    import { shippingCompanyCodes } from "../../../config"
    import { tooltip } from "../../../helper"
    import { _ } from "svelte-i18n"
    export let position: OperationPosition
    export let disabledLink: boolean = false

    let outerWidth = window.outerWidth
    let outerHeight: number

    $: isMobile = outerWidth <= 500 || outerHeight <= 500

    function trackingStatus(t: OperationPositionTracking): string {
        if (t.status >= 99) return $_("components.table.fields.trackingList.delivered")
        if (t.status >= 50) return $_("components.table.fields.trackingList.inDelivery")
        if (t.status >= 1) return $_("components.table.fields.trackingList.inTransit")
        return $_("components.table.fields.trackingList.noData")
    }

    function getLink(t: OperationPositionTracking): string {
        if (disabledLink) {
            return null
        }

        switch (position.delivery?.shippingCompany) {
            case 1003:
                return "https://tracking.dpd.de/status/de_DE/parcel/" + t.trackingNumber
            case 1006:
            case 1060:
                return "https://www.diefixenkunzendorfer.de/tracking?nve=" + t.trackingNumber
            case 1068:
                return "https://de.kuehne-nagel.com/search?query=" + t.trackingNumber
            default:
                return null
        }
    }

    function getTooltip(t: OperationPositionTracking): string {
        const shippingCompany = shippingCompanyCodes[position.delivery.shippingCompany].de
        switch (position.delivery?.shippingCompany) {
            case 1003:
            case 1006:
            case 1060:
            case 1068:
                return $_("components.table.fields.trackingList.externalLink", {
                    values: {
                        shippingCompany,
                    },
                })
            default:
                return (
                    $_("components.table.fields.trackingList.noTrackingLink") +
                    (shippingCompany
                        ? "\n\n" +
                          $_("components.table.fields.trackingList.shippingCompany", {
                              values: {
                                  shippingCompany,
                              },
                          })
                        : "")
                )
        }
    }
</script>

<style lang="less">
    .isLargeDev .list {
        max-height: 350px;
        overflow-y: auto;
    }
    .isSmallDev {
        position: fixed;
        left: 0px;
        top: 0px;
        height: 100%;
        width: 100%;
        background-color: #fff;
        .list {
            margin-top: 30px;
            padding: 20px;
        }
    }
</style>

<svelte:window bind:outerHeight bind:outerWidth />

<div class:isSmallDev="{isMobile}" class:isLargeDev="{!isMobile}">
    <div class="list">
        {#each position.tracking || [] as t}
            <a
                rel="noreferrer"
                href="{getLink(t)}"
                target="_blank"
                class="item"
                class:green="{t.status >= 99}"
                class:yellow="{t.status < 99}"
                class:red="{t.status < 0}"
                on:click="{function (e) {
                    if (!this.href) {
                        e.preventDefault()
                    }
                }}"
                use:tooltip="{!disabledLink ? { content: getTooltip(t) } : null}"
            >
                <span class="icon">
                    <span class="material-icons">local_shipping</span>
                </span>
                <span class="text">
                    <span class="id">{t.trackingNumber}</span>
                    <span class="info">{trackingStatus(t)}</span>
                    {#if t.receiver}
                        <span class="name"
                            >{$_("components.table.fields.trackingList.receipt", {
                                values: { receiver: t.receiver },
                            })}</span
                        >
                    {/if}
                </span>
                {#if !disabledLink}
                    <span class="icon2">
                        <span class="material-icons">chevron_right</span>
                    </span>
                {/if}
            </a>
        {/each}
    </div>
</div>
